import { chakra } from '@plurall/elo-v3';

import {
  creditsModalContentRecipe,
  creditsModalCreditsRecipe,
  creditsModalTitleRecipe,
  creditsTriggerIconRecipe,
  creditsTriggerRecipe,
  creditsTriggerTextRecipe,
} from './credits.recipe';

export const CreditsTriggerFactory = chakra('button', creditsTriggerRecipe);
export const CreditsTriggerIconFactory = chakra('div', creditsTriggerIconRecipe);
export const CreditsTriggerTextFactory = chakra('span', creditsTriggerTextRecipe);
export const CreditsModalContentFactory = chakra('div', creditsModalContentRecipe);
export const CreditsModalTitleFactory = chakra('h3', creditsModalTitleRecipe);
export const CreditsModalCreditsFactory = chakra('p', creditsModalCreditsRecipe);
